module.exports = __webpack_public_path__ + "img/box1_img.ef91c4f5.png";